/**
 * @name results.controller:advancedSearch
 * @description
 * Controller for advancedSearch directive. On click open compile
 * initial view of advanced search. Keep inside couple of
 * methods for 'reset', 'select', 'back' and 'done' buttons
 */
export default ($scope, $element) => {
    'ngInject';
    $scope.type = $element.data('type');
    $scope.typeCapitalysed =
        $scope.type.replace($scope.type.charAt(0), $scope.type.charAt(0).toUpperCase());
    $scope.datePickerCalendarClass = `js-datePicker_${$scope.type}`;
    $scope.MIN_DATE = '1988-01-01'; // The date from which the results starts

    $scope.datePickerInitOff = $scope.$on('datePickerInit', (event, data) => {
        $scope.datePicker = $element.datePicker($scope.getInitialDatePickerObject(data));

        $scope.datePicker.on('show.rp.datePicker', () => {
            $scope.$emit('datePickerShow', $scope.type);
        }).on('hidden.rp.datePicker', () => {
            $scope.$emit('datePickerHidden');
        }).on('change.rp.datePicker', (changeEvent, date) => {
            $scope.$emit('datePickerChange', {
                date,
                type: $scope.type
            });
        });

        // Important: Add appropriate data-test-selectors for automation testing, don't miss it.
        angular.element(`.${$scope.datePickerCalendarClass}`)
            .attr('data-test-selector',
                `block-datePickerAdvSearch${$scope.typeCapitalysed}`);
    });

    $scope.datePickerHideOff = $scope.$on('datePickerHide', () => {
        if ($(`.${$scope.datePickerCalendarClass}`).is(':visible')) {
            $scope.datePicker.datePicker('hide');
        }
    });

    $scope.datePickerResetOff = $scope.$on('datePickerReset', () => {
        $scope.datePicker.datePicker('restoreState');
    });

    $scope.datePickerChangedOff = $scope.$on('datePickerChanged', (event, data) => {
        if ($scope.type !== data.type) {
            const property = data.type === 'from' ? 'minDate' : 'maxDate';
            $scope.datePicker.datePicker(property, data.date);
        }
    });

    $scope.datePickerDestroyOff = $scope.$on('datePickerDestroy', () => {
        $scope.datePicker.datePicker('destroy');
        $scope.setDatePicker(null);
        $scope.datePickerInitOff();
        $scope.datePickerHideOff();
        $scope.datePickerResetOff();
        $scope.datePickerChangedOff();
        $scope.datePickerDestroyOff();
    });

    $scope.setDatePicker = (value) => {
        $scope.datePicker = value;
    };

    $scope.getInitialDatePickerObject = (data) => {
        const initialDatePicker = {
            date: data[$scope.type],
            maxDate: moment(),
            minDate: $scope.MIN_DATE,
            container: data.container,
            monthPickerAutoClose: false,
            css: {
                picker: `ui-datePicker ${$scope.datePickerCalendarClass}`
            },
            autoClose: true
        };

        return initialDatePicker;
    };
};



// WEBPACK FOOTER //
// ./src/js/controllers/directiveDatePickerWrapper.js